import React from 'react';
import PropTypes from 'prop-types';
import { translate as t } from '../../lib/I18n';
import TrainIcon from '../icons/TrainIcon';
import CarIcon from '../icons/CarIcon';
import config from '../../config';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import ProgressBar from '../general/ProgressBar';

const CarbonFootprintModalInfoSection = ({ carbonCalculationData }) => {
    const carbonFootprint = config.get('carbonFootprint') || '';
    const {
        carEmissions,
        carPercentage,
        trainEmissions,
        trainPercentage,
        distance,
        origin,
        destination,
    } = carbonCalculationData;

    const renderTransportCards = () => {
        const transportEmissionsCardsConfig = [
            {
                title: t('carbonFootprint.modal.info.card-train.title'),
                iconComponent: <TrainIcon />,
                emission: trainEmissions,
                color: 'green',
                percentage: trainPercentage,
            },
            {
                title: t('carbonFootprint.modal.info.card-car.title'),
                iconComponent: <CarIcon />,
                emission: carEmissions,
                color: 'red',
                percentage: carPercentage,
            }
        ];

        return transportEmissionsCardsConfig.map(({ title, iconComponent, emission, color, percentage }) => (
            <li className={`carbon-footprint-modal__info--card carbon-footprint-modal__background--${color}`} key={title}>
                <div className='carbon-footprint-modal__info--card-title-container'>
                    <h5 className='carbon-footprint-modal__title'>{ title }</h5>
                    { iconComponent }
                </div>
                <p className='carbon-footprint-modal__info--card-subtitle'>
                    { t('carbonFootprint.modal.info.card.subtitle') }
                </p>
                <p className={`carbon-footprint-modal__info--card-text-${color}`}>
                    { t('carbonFootprint.modal.info.card.emission', { emission }) }
                </p>
                <ProgressBar completed={percentage} containerStyle={{ backgroundColor: 'white', boxShadow: 'none', marginTop: 10, borderColor: 'white', borderWidth: 1, height: 8 }} style={{ backgroundColor: color, height: 6, top: 1, left: 1 }} total={100} />
            </li>
        ));
    };

    return (
        <div className='carbon-footprint-modal__info--container'>
            <h4 className='carbon-footprint-modal__title'>
                { t('carbonFootprint.modal.info.title', { distance, origin, destination } ) }
            </h4>
            <ul className='carbon-footprint-modal__info--cards-container'>
                { renderTransportCards() }
            </ul>
            <p className='carbon-footprint-modal__text'>
                <FormattedHTMLMessage message="carbonFootprint.modal.info.paragraph1" />
            </p>
            <p className='carbon-footprint-modal__text'>
                <FormattedHTMLMessage message="carbonFootprint.modal.info.paragraph2" />
            </p>
            <p className='carbon-footprint-modal__text no-margin'>
                <FormattedHTMLMessage message="carbonFootprint.modal.info.paragraph3" />
                <a href={carbonFootprint} target="_blank" className='carbon-footprint-modal__link'>
                    { t('carbonFootprint.modal.info.paragraph3.link') }
                </a>
            </p>
        </div>
    );
};

CarbonFootprintModalInfoSection.propTypes = {
    carbonCalculationData: PropTypes.object.isRequired,
};

export default CarbonFootprintModalInfoSection;
